import React from 'react';
import PortableText from 'libs/sanity/components/PortableText';
import Text from 'components/Text';
import Button from 'components/Button';
import type { ButtonLinkArrayComponent, CategoryDescriptionBlock } from 'libs/sanity/types/generated';
import styled from 'libs/styled';
import { richTextTagStyles } from 'libs/sanity/components/PortableText/richTextTagStyles';

export type CategoryDescriptionComponentProps = CategoryDescriptionBlock;

// Scoped to Portable Text only so heading typography is not overridden.
const RichTextWrapper = styled('div')`
    ${richTextTagStyles}
`;

const ButtonsWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-top: 20px;
`;

const headingTypography: Array<string | null> = [
    'Primary/Mobile/18_120_510_-3',
    null,
    null,
    null,
    'Primary/20_120_510_-3',
];

const textTypography: Array<string | null> = [
    'Secondary/Mobile/18_120_400_-1_Indent',
    null,
    null,
    null,
    'Secondary/20_120_400_-1_Indent',
];

const CategoryDescriptionComponent = ({ heading, richText, buttons }: CategoryDescriptionComponentProps) => {
    const hasRichText = Array.isArray(richText) && richText.length > 0;
    const hasButtons = Array.isArray(buttons) && buttons.length > 0;

    if (!heading && !hasRichText && !hasButtons) {
        return null;
    }

    return (
        <div className="CategoryDescription">
            {heading && (
                <Text $as="h2" typography={headingTypography}>
                    {heading}
                </Text>
            )}
            {hasRichText && (
                <RichTextWrapper>
                    <PortableText value={richText} typography={textTypography} />
                </RichTextWrapper>
            )}
            {hasButtons && (
                <ButtonsWrapper>
                    {buttons.map((button: ButtonLinkArrayComponent[number], index) => {
                        if (button.type !== 'buttonLinkComponent') {
                            return null;
                        }
                        return (
                            <Button
                                key={button.key ?? `button-${index}`}
                                theme="textButtonUnderline"
                                sanityLink={button}
                                size="large"
                            >
                                {button.label}
                            </Button>
                        );
                    })}
                </ButtonsWrapper>
            )}
        </div>
    );
};

export default CategoryDescriptionComponent;
